import { ResultProc } from '@app/models/system/result-proc.model';
import { Member } from '@models/myoffice/member/member.model'
import { createAction, props } from "@ngrx/store";

export const findListMemberNullPid = createAction(
    '[ListMemberNullPid API] Load FindList',
    props<{ params: any }>()
);

export const findListMemberNullPidSuccess = createAction(
    '[ListMemberNullPid API] Load FindList Success',
    props<{ member: Member[] }>()
);

export const findListMemberNullPidFailure = createAction(
    '[ListMemberNullPid API] Load FindList Failure',
    props<{ msg: any }>()
);

/* countLine */
export const countListMemberNullPid = createAction(
    '[CountMemberNullPid API] Load CountList',
    props<{ params: any }>()
);

export const countListMemberNullPidSuccess = createAction(
    '[CountMemberNullPid API] Load CountList Success',
    props<{ total: Number }>()
);

export const countListMemberNullPidFailure = createAction(
    '[CountMemberNullPid API] Load CountList Failure',
    props<{ msg: any }>()
);

export const savePid = createAction(
    '[SavePid API] Load savePid',
    props<{ params: any }>()
);

export const savePidSuccess = createAction(
    '[SavePid API] Load SavePid Success',
    props<{ result: ResultProc }>()
);

export const savePidFailure = createAction(
    '[SavePid API] Load SavePid Failure',
    props<{ msg: any }>()
);
